var _defs, _g, _g2, _g3, _g4, _g5, _g6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFailedIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 200,
    zoomAndPan: "magnify",
    viewBox: "0 0 150 149.999998",
    height: 200,
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "96e04f701e"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 15 3 L 136 3 L 136 147 L 15 147 Z M 15 3 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "01dc0a32a8"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M -1.46875 18.433594 L 125.871094 -13.371094 L 160.761719 126.335938 L 33.425781 158.140625 Z M -1.46875 18.433594 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "11932ccce1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M -1.46875 18.433594 L 125.871094 -13.371094 L 160.761719 126.335938 L 33.425781 158.140625 Z M -1.46875 18.433594 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "64f8b8eb44"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M -1.46875 18.433594 L 125.871094 -13.371094 L 160.761719 126.335938 L 33.425781 158.140625 Z M -1.46875 18.433594 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "f177aa5bb7"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 13 1 L 139 1 L 139 149 L 13 149 Z M 13 1 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "ab451768ac"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M -1.46875 18.433594 L 125.871094 -13.371094 L 160.761719 126.335938 L 33.425781 158.140625 Z M -1.46875 18.433594 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "450ecf6e2a"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M -1.46875 18.433594 L 125.871094 -13.371094 L 160.761719 126.335938 L 33.425781 158.140625 Z M -1.46875 18.433594 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "ce9deb80a0"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M -1.46875 18.433594 L 125.871094 -13.371094 L 160.761719 126.335938 L 33.425781 158.140625 Z M -1.46875 18.433594 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "f03f1c676c"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 19 50 L 71 50 L 71 77 L 19 77 Z M 19 50 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "1c0a129d98"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M -1.46875 18.433594 L 125.871094 -13.371094 L 160.761719 126.335938 L 33.425781 158.140625 Z M -1.46875 18.433594 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "985ce40074"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M -1.46875 18.433594 L 125.871094 -13.371094 L 160.761719 126.335938 L 33.425781 158.140625 Z M -1.46875 18.433594 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "1a6bba5518"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M -1.46875 18.433594 L 125.871094 -13.371094 L 160.761719 126.335938 L 33.425781 158.140625 Z M -1.46875 18.433594 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "451b9da7e8"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 23 33 L 78 33 L 78 61 L 23 61 Z M 23 33 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "9be562e7ec"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M -1.46875 18.433594 L 125.871094 -13.371094 L 160.761719 126.335938 L 33.425781 158.140625 Z M -1.46875 18.433594 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "966f045678"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M -1.46875 18.433594 L 125.871094 -13.371094 L 160.761719 126.335938 L 33.425781 158.140625 Z M -1.46875 18.433594 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "326702553f"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M -1.46875 18.433594 L 125.871094 -13.371094 L 160.761719 126.335938 L 33.425781 158.140625 Z M -1.46875 18.433594 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "ab9ead405b"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 32 19 L 79 19 L 79 44 L 32 44 Z M 32 19 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: 4309535391
  }, /*#__PURE__*/React.createElement("path", {
    d: "M -1.46875 18.433594 L 125.871094 -13.371094 L 160.761719 126.335938 L 33.425781 158.140625 Z M -1.46875 18.433594 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: 490476340
  }, /*#__PURE__*/React.createElement("path", {
    d: "M -1.46875 18.433594 L 125.871094 -13.371094 L 160.761719 126.335938 L 33.425781 158.140625 Z M -1.46875 18.433594 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "5f7e8f8c49"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M -1.46875 18.433594 L 125.871094 -13.371094 L 160.761719 126.335938 L 33.425781 158.140625 Z M -1.46875 18.433594 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "b75f9aa4ad"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 47 5 L 80 5 L 80 29 L 47 29 Z M 47 5 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "da31350fcb"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M -1.46875 18.433594 L 125.871094 -13.371094 L 160.761719 126.335938 L 33.425781 158.140625 Z M -1.46875 18.433594 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "06fb0c9559"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M -1.46875 18.433594 L 125.871094 -13.371094 L 160.761719 126.335938 L 33.425781 158.140625 Z M -1.46875 18.433594 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "6433bb41e6"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M -1.46875 18.433594 L 125.871094 -13.371094 L 160.761719 126.335938 L 33.425781 158.140625 Z M -1.46875 18.433594 ",
    clipRule: "nonzero"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#96e04f701e)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#01dc0a32a8)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#11932ccce1)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#64f8b8eb44)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ff5555",
    d: "M 129.132812 65.734375 C 125.441406 68.996094 117.265625 67.757812 112.601562 71.222656 C 104.140625 77.507812 96.082031 94.667969 92.691406 99.261719 C 86.609375 107.515625 80.203125 111.949219 77.953125 121.429688 C 76.796875 126.292969 76.523438 137.5 73.101562 143.28125 C 72.339844 144.574219 70.191406 146.136719 68.699219 146.285156 C 64.964844 146.648438 62.257812 144.722656 59.316406 142.378906 C 56.792969 140.371094 54.675781 137.628906 54.082031 134.453125 C 51.976562 123.164062 62.03125 112.820312 62.632812 101.355469 C 62.851562 97.132812 63.816406 91.558594 60.585938 88.828125 C 56.503906 85.375 42.847656 89.730469 34.292969 87.792969 C 28.917969 86.574219 22.671875 85.464844 19.101562 81.265625 C 16.257812 77.921875 15.265625 72.824219 15.910156 68.484375 C 16.417969 65.042969 19.398438 63.382812 19.738281 59.921875 C 20.082031 56.40625 17.027344 53.035156 17.695312 49.566406 C 18.457031 45.597656 23.40625 42.871094 24.839844 39.089844 C 25.867188 36.382812 24.480469 34.417969 25.734375 31.808594 C 27.738281 27.628906 32.015625 27.089844 34.414062 23.121094 C 35.914062 20.632812 36.515625 16.898438 38.242188 14.558594 C 40.820312 11.066406 45.503906 9.414062 49.730469 8.433594 C 54.707031 7.277344 58.089844 8.617188 63.132812 7.800781 C 67.835938 7.039062 73.691406 3.707031 78.449219 3.976562 C 90.25 4.640625 98.53125 15.410156 110.109375 19.96875 C 114.59375 21.734375 120.296875 16.78125 124.53125 19.082031 C 132.050781 23.171875 134.589844 32.808594 135.511719 41.328125 C 136.464844 50.101562 135.742188 59.898438 129.132812 65.734375 Z M 129.132812 65.734375 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })))))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#f177aa5bb7)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#ab451768ac)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#450ecf6e2a)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#ce9deb80a0)"
  }, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    transform: "matrix(0.51058, -0.127519, 0.127701, 0.511305, -191.417947, -74.793906)",
    fill: "none",
    strokeLinejoin: "round",
    d: "M 526.25073 406.089264 C 517.943575 410.396662 503.441166 404.357956 493.247332 408.592085 C 474.755146 416.272514 451.997447 444.158227 443.631484 451.056119 C 428.618473 463.454695 414.76676 468.67121 406.253581 485.089731 C 401.882725 493.511145 396.218487 514.016967 387.248143 523.086614 C 385.248536 525.116674 380.568324 527.005335 377.749037 526.592516 C 370.697217 525.54429 366.593339 520.754379 362.249824 515.087248 C 358.522183 510.230736 355.881622 504.209066 356.249257 498.089626 C 357.565603 476.339005 380.864695 461.919703 387.252558 441.090129 C 389.600107 433.417023 393.945437 423.598805 389.247077 417.086839 C 383.311548 408.852967 356.129981 410.592221 341.250981 403.092076 C 331.902993 398.377082 320.898729 393.462925 316.250115 384.090815 C 312.547073 376.627638 313.065067 366.786934 316.251527 359.093859 C 318.772264 352.991899 325.031342 351.306013 327.25141 345.090868 C 329.503861 338.776841 325.424533 331.166341 328.253118 325.087679 C 331.484755 318.13165 341.864359 315.387767 346.248308 309.085833 C 349.388699 304.57469 347.736885 300.319926 351.249993 296.092733 C 356.868804 289.319517 365.002558 290.293787 371.251588 284.090295 C 375.162629 280.199179 377.991094 273.600984 382.251471 270.087304 C 388.612339 264.843755 398.007636 263.955322 406.251012 264.093639 C 415.957995 264.25319 421.577505 268.275135 431.250435 269.090853 C 440.271662 269.850993 452.600775 266.409155 461.247996 269.092915 C 482.69771 275.741233 493.006011 299.374953 512.252056 313.09052 C 519.706319 318.402787 532.50099 311.906557 539.247957 318.089071 C 551.227562 329.075617 551.471373 347.983722 549.248195 364.091586 C 546.965719 380.681246 541.122608 398.384503 526.25073 406.089264 Z M 526.25073 406.089264 ",
    stroke: "#550000",
    strokeWidth: 10,
    strokeOpacity: 1,
    strokeMiterlimit: 4
  })))))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#f03f1c676c)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#1c0a129d98)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#985ce40074)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#1a6bba5518)"
  }, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    transform: "matrix(0.51058, -0.127519, 0.127701, 0.511305, -191.417947, -74.793906)",
    fill: "none",
    strokeLinejoin: "round",
    d: "M 331.247849 344.590186 C 331.247849 344.590186 359.764036 337.820671 371.747487 342.092824 C 387.259716 347.611763 395.483135 354.865363 411.247909 362.58642 C 414.396903 364.128116 416.708025 370.18222 414.748227 373.093142 C 409.619275 380.691387 397.884396 384.785651 388.748314 385.585937 C 376.910116 386.636727 364.12636 378.070065 355.252355 375.589496 C 352.477991 374.813532 345.749185 377.092766 345.749185 377.092766 ",
    stroke: "#550000",
    strokeWidth: 10,
    strokeOpacity: 1,
    strokeMiterlimit: 4
  })))))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#451b9da7e8)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#9be562e7ec)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#966f045678)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#326702553f)"
  }, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    transform: "matrix(0.51058, -0.127519, 0.127701, 0.511305, -191.417947, -74.793906)",
    fill: "none",
    strokeLinejoin: "round",
    d: "M 349.251588 311.087772 C 349.248069 311.438323 373.012823 309.962321 387.248468 314.589898 C 400.211241 318.800703 407.723477 325.68594 430.752764 335.593115 C 440.47148 339.774108 434.203926 343.72689 432.750104 347.092511 C 429.664328 354.230075 414.753228 363.590522 414.753228 363.590522 ",
    stroke: "#550000",
    strokeWidth: 10,
    strokeOpacity: 1,
    strokeMiterlimit: 4
  })))))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#ab9ead405b)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#4309535391)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#49047634e1)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#5f7e8f8c49)"
  }, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    transform: "matrix(0.51058, -0.127519, 0.127701, 0.511305, -191.417947, -74.793906)",
    fill: "none",
    strokeLinejoin: "round",
    d: "M 372.249157 285.087786 C 372.249157 285.087786 392.237438 285.557762 400.751868 290.087787 C 413.654047 296.957397 429.009764 302.949166 441.748067 309.586912 C 445.349001 311.462874 444.912985 317.702776 443.749124 321.59146 C 442.059999 327.243804 431.753471 334.58977 431.753471 334.58977 ",
    stroke: "#550000",
    strokeWidth: 10,
    strokeOpacity: 1,
    strokeMiterlimit: 4
  })))))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#b75f9aa4ad)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#da31350fcb)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#06fb0c9559)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#6433bb41e6)"
  }, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    transform: "matrix(0.51058, -0.127519, 0.127701, 0.511305, -191.417947, -74.793906)",
    fill: "none",
    strokeLinejoin: "round",
    d: "M 406.892015 264.589655 C 406.892015 264.589655 441.061502 275.594447 450.754329 284.589675 C 453.343644 286.992596 451.373932 293.736206 450.251354 297.092763 C 448.466748 302.453903 440.253282 307.090258 440.253282 307.090258 ",
    stroke: "#550000",
    strokeWidth: 10,
    strokeOpacity: 1,
    strokeMiterlimit: 4
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFailedIcon);
export default __webpack_public_path__ + "static/media/failed-icon.9505192b590bf94b488a74421a46ff11.svg";
export { ForwardRef as ReactComponent };